import React, {PureComponent} from "react"
import styled from "styled-components"
import {Card} from "@irati/ui/src/Layout"
import {H2} from "@irati/ui/src//Typography/Heading"
import {Label2} from "@irati/ui/src/Labels"
import FormattedMessage from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import id from "@irati/utils/id"

const StyledCard = styled(Card)`
  max-width: 600px;
  margin: 0 auto;
  ${Label2} {
    max-width: 380px;
    margin: 0 auto;
  }
`

const FlexCenter = styled.div`
  text-align: center;
`

interface Props {
  id?: string
  title?: any
  body?: any
  buttonText?: string
  onRetry?: () => void
  hasShadow?: boolean
}

export default class YouNeedToMfa extends PureComponent<Props> {
  render() {
    const {onRetry, hasShadow = true} = this.props
    const idNameSpace = id("mfaYouNeed", {id: this.props.id || "mfa"})

    const title = this.props.title || <FormattedMessage id="platform.mfa.error.youNeed.title" />
    const body = this.props.body || <FormattedMessage id="platform.mfa.error.youNeed.body" />
    const buttonText = this.props.buttonText || <FormattedMessage id="platform.mfa.error.youNeed.buttonText" />

    return (
      <StyledCard id={idNameSpace} noBorder={!hasShadow}>
        <FlexCenter>
          <H2 small>{title}</H2>
          <Label2 block medium>
            {body}
          </Label2>
          {onRetry && (
            <Button id={id("button", idNameSpace)} primary onClick={onRetry}>
              {buttonText}
            </Button>
          )}
        </FlexCenter>
      </StyledCard>
    )
  }
}
